import { TextVariableInput } from '@gift/text-core/TextVariableInput';
import { Json } from '@gift/types/Json';
import { edit } from './mergeInputsIntoPrefab';

export function mergeTextIntoPrefab(
    prefabInput: Json.Input<TextVariableInput>,
    userInput: Json.Input<TextVariableInput>,
    maxLength: number,
    direction: string
): Json.Input<TextVariableInput> {

    const fromPrefab = prefabInput.value;
    const fromUser = userInput.value;

    const defaultContent = direction === 'inputIntoPrefab'
        ? fromPrefab.content
        : '';

    const content = fromUser.content && fromUser.content.length <= maxLength
        ? fromUser.content
        : defaultContent;

    return edit(prefabInput, {

        content: content,
        fontFamily: fromUser.fontFamily || fromPrefab.fontFamily,

        // If the prefab has a non-default font style/weight, that's considered
        // a design feature that should be retained.

        fontStyle: fromUser.fontStyle === 'normal'
            ? fromUser.fontStyle || fromPrefab.fontStyle
            : fromUser.fontStyle,

        fontWeight: fromUser.fontWeight === 'normal'
            ? fromUser.fontWeight || fromPrefab.fontWeight
            : fromUser.fontWeight
    });
}